import {
  createContext,
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
  useContext,
} from 'react'
import PropTypes from 'prop-types'

import { OnboardingContext } from './OnboardingContext.jsx'
import getByPath from '@/helpers/getByPath'

export const AIConfigContext = createContext()

/**
 * =======================================================
 * PASTE YOUR SAMPLE AI RESPONSE BELOW
 * =======================================================
 * This mock data will be used until the actual API is connected.
 * Structure this to match the expected AI response format.
 */
const MOCK_AI_RESPONSE = {
  contact: {
    blocks: {
      cover: {
        elements: [
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1480944657103-7fed22359e1d?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDE0fHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
        ],
      },
      contact: {
        elements: [
          {
            icon: {
              url: 'icons:38242',
              type: 'service',
            },
          },
          {
            icon: {
              url: 'icons:74399',
              type: 'service',
            },
          },
          {
            icon: {
              url: 'icons:74415',
              type: 'service',
            },
          },
          {
            icon: {
              url: 'icons:74785',
              type: 'service',
            },
          },
          {
            mapAddress: {
              content: '123 Business Lane, Suite 100',
            },
          },
          {
            title: {
              content: 'Get in Touch',
            },
          },
        ],
      },
      accountInfo: {
        companyName: {
          content: '',
        },
        fullName: {
          content: 'Mr./Mrs. Smith ',
        },
        address: {
          content: '1234 Street, New York, NY 10002',
        },
        phone: {
          content: '555-555-5555',
        },
        email: {
          content: 'anil.kamath+eccom16042025nsoll@newfold.com',
        },
      },
    },
  },
  reviews: {
    blocks: {
      testimonials: {
        elements: [
          {
            title: {
              content: 'Reliable Business Solutions',
            },
          },
          {
            image: {
              content: null,
              type: 'portrait',
              orientation: 'portrait',
              url: 'https://images.unsplash.com/photo-1769636930451-e8df6d839e4d?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDIyfHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            description: {
              content: 'Their services have truly transformed our operations.',
            },
          },
          {
            fullName: {
              content: 'John D.',
            },
          },
          {
            image: {
              content: null,
              type: 'portrait',
              orientation: 'portrait',
              url: 'https://images.unsplash.com/photo-1564520245432-d0b03e8712b6?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDEwfHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            description: {
              content: 'Exceptional support and tailored solutions.',
            },
          },
          {
            fullName: {
              content: 'Emma R.',
            },
          },
          {
            image: {
              content: null,
              type: 'portrait',
              orientation: 'portrait',
              url: 'https://images.unsplash.com/photo-1717068341511-204207d72705?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDIwfHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            description: {
              content: 'A partnership that has boosted our growth.',
            },
          },
          {
            fullName: {
              content: 'Michael Lee',
            },
          },
          {
            image: {
              content: null,
              type: 'portrait',
              orientation: 'portrait',
              url: 'https://images.unsplash.com/photo-1677543167033-af3c688aa4df?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDEzfHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            description: {
              content: 'Professional and dedicated to our success.',
            },
          },
          {
            fullName: {
              content: 'Sarah P.',
            },
          },
          {
            image: {
              content: null,
              type: 'portrait',
              orientation: 'portrait',
              url: 'https://images.unsplash.com/photo-1717068341198-95cce0b54b26?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDIxfHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            description: {
              content: 'Innovative ideas that drive results.',
            },
          },
          {
            fullName: {
              content: 'David S.',
            },
          },
          {
            image: {
              content: null,
              type: 'portrait',
              orientation: 'portrait',
              url: 'https://images.unsplash.com/photo-1643224196036-a61f69ff4144?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            description: {
              content: 'Their commitment to excellence is unmatched.',
            },
          },
          {
            fullName: {
              content: 'Linda T.',
            },
          },
          {
            image: {
              content: null,
              type: 'portrait',
              orientation: 'portrait',
              url: 'https://images.unsplash.com/photo-1662838496399-f8e312b566fc?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDd8fHBvcnRyYWl0JTIwcGVyc29uJTIwZmFjZXxlbnwwfDF8fHwxNzczNzY3OTc0fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            description: {
              content: 'We highly recommend their comprehensive services.',
            },
          },
          {
            fullName: {
              content: 'Kevin W.',
            },
          },
          {
            image: {
              content: null,
              type: 'portrait',
              orientation: 'portrait',
              url: 'https://images.unsplash.com/photo-1694106192312-08d813b3d2ef?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDl8fHBvcnRyYWl0JTIwcGVyc29uJTIwZmFjZXxlbnwwfDF8fHwxNzczNzY3OTc0fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            description: {
              content: 'Solutions that are always ahead of the curve.',
            },
          },
          {
            fullName: {
              content: 'Jessica N.',
            },
          },
        ],
      },
      accountInfo: {
        companyName: {
          content: '',
        },
        fullName: {
          content: 'Mr./Mrs. Smith ',
        },
        address: {
          content: '1234 Street, New York, NY 10002',
        },
        phone: {
          content: '555-555-5555',
        },
        email: {
          content: 'anil.kamath+eccom16042025nsoll@newfold.com',
        },
      },
    },
  },
  aboutus: {
    blocks: {
      aboutUs1: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            description: {
              content:
                'We provide a diverse range of services tailored to help your business thrive. Our focus is on quality, ensuring customer satisfaction and building enduring partnerships with our clients.',
            },
          },
        ],
      },
      cover: {
        elements: [
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDEyfHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
        ],
      },
      aboutUs3: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            description: {
              content:
                'Explore our extensive range of services tailored to help you succeed in your industry. We prioritize quality and aim to build lasting relationships with our clients through dedicated support and innovative strategies.',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDd8fGJ1c2luZXNzfGVufDB8MHx8fDE3NzM3MjM3Mjh8MA&ixlib=rb-4.1.0&w=2000',
            },
          },
        ],
      },
      aboutUs2: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            description: {
              content:
                'Dedicated to meeting your diverse business needs efficiently.',
            },
          },
          {
            title: {
              content: 'Quality and Reliability',
            },
          },
          {
            title: {
              content: 'Client Satisfaction Focus',
            },
          },
          {
            title: {
              content: 'Building Strong Partnerships',
            },
          },
          {
            description: {
              content:
                'We prioritize high-quality services tailored to your needs.',
            },
          },
          {
            description: {
              content:
                'Our goal is to ensure client satisfaction in every engagement.',
            },
          },
          {
            description: {
              content:
                'We foster long-lasting relationships with every client.',
            },
          },
        ],
      },
      accountInfo: {
        companyName: {
          content: '',
        },
        fullName: {
          content: 'Mr./Mrs. Smith ',
        },
        address: {
          content: '1234 Street, New York, NY 10002',
        },
        phone: {
          content: '555-555-5555',
        },
        email: {
          content: 'anil.kamath+eccom16042025nsoll@newfold.com',
        },
      },
    },
  },
  portfolio: {
    blocks: {
      portfolio3: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            description: {
              content:
                'Explore our wide range of services tailored to enhance your business success.',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1480944657103-7fed22359e1d?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDE0fHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDIzfHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
        ],
      },
      portfolio2: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            description: {
              content:
                'Explore our diverse services tailored to enhance your business success.',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDV8fGJ1c2luZXNzfGVufDB8MHx8fDE3NzM3MjM3Mjh8MA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDE1fHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
        ],
      },
      portfolio1: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
        ],
      },
      portfolio4: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            description: {
              content:
                'We provide tailored services to enhance your business success and growth.',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDl8fGJ1c2luZXNzfGVufDB8MHx8fDE3NzM3MjM3Mjh8MA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1480944657103-7fed22359e1d?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDE0fHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
        ],
      },
      accountInfo: {
        companyName: {
          content: '',
        },
        fullName: {
          content: 'Mr./Mrs. Smith ',
        },
        address: {
          content: '1234 Street, New York, NY 10002',
        },
        phone: {
          content: '555-555-5555',
        },
        email: {
          content: 'anil.kamath+eccom16042025nsoll@newfold.com',
        },
      },
    },
  },
  team: {
    blocks: {
      team: {
        elements: [
          {
            title: {
              content: 'Our Expertise',
            },
          },
          {
            fullName: {
              content: 'Jane Doe',
            },
          },
          {
            subtitle: {
              content: 'Business Consultant',
            },
          },
          {
            description: {
              content:
                'Jane brings over 10 years of industry experience to help businesses grow.',
            },
          },
          {
            image: {
              url: 'https://images.unsplash.com/photo-1656338997878-279d71d48f6e?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDE5fHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
              type: 'portrait',
              orientation: 'portrait',
            },
          },
          {
            fullName: {
              content: 'John Smith',
            },
          },
          {
            subtitle: {
              content: 'Marketing Specialist',
            },
          },
          {
            description: {
              content:
                'John develops innovative marketing strategies that enhance brand visibility.',
            },
          },
          {
            image: {
              url: 'https://images.unsplash.com/photo-1728557349552-c1660fbdff7c?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDExfHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
              type: 'portrait',
              orientation: 'portrait',
            },
          },
          {
            fullName: {
              content: 'Alice Johnson',
            },
          },
          {
            subtitle: {
              content: 'Account Manager',
            },
          },
          {
            description: {
              content:
                'Alice ensures client satisfaction through tailored solutions and support.',
            },
          },
          {
            image: {
              url: 'https://images.unsplash.com/photo-1720463671506-7da8ab4a7040?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDV8fHBvcnRyYWl0JTIwcGVyc29uJTIwZmFjZXxlbnwwfDF8fHwxNzczNzY3OTc0fDA&ixlib=rb-4.1.0&w=2000',
              type: 'portrait',
              orientation: 'portrait',
            },
          },
          {
            fullName: {
              content: 'Robert Brown',
            },
          },
          {
            subtitle: {
              content: 'Financial Analyst',
            },
          },
          {
            description: {
              content:
                'Robert provides insights for informed financial decision-making and planning.',
            },
          },
          {
            image: {
              url: 'https://images.unsplash.com/photo-1662838496399-f8e312b566fc?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDd8fHBvcnRyYWl0JTIwcGVyc29uJTIwZmFjZXxlbnwwfDF8fHwxNzczNzY3OTc0fDA&ixlib=rb-4.1.0&w=2000',
              type: 'portrait',
              orientation: 'portrait',
            },
          },
          {
            fullName: {
              content: 'Emily Davis',
            },
          },
          {
            subtitle: {
              content: 'Operations Director',
            },
          },
          {
            description: {
              content:
                'Emily optimizes processes to enhance operational efficiency across teams.',
            },
          },
          {
            image: {
              url: 'https://images.unsplash.com/photo-1741723972126-3f53bb019272?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDI0fHxwb3J0cmFpdCUyMHBlcnNvbiUyMGZhY2V8ZW58MHwxfHx8MTc3Mzc2Nzk3NHww&ixlib=rb-4.1.0&w=2000',
              type: 'portrait',
              orientation: 'portrait',
            },
          },
          {
            fullName: {
              content: 'Michael Wilson',
            },
          },
          {
            subtitle: {
              content: 'IT Specialist',
            },
          },
          {
            description: {
              content:
                'Michael oversees technology integration to improve business operations.',
            },
          },
          {
            image: {
              url: 'https://images.unsplash.com/photo-1657682041300-804b68d609fa?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDh8fHBvcnRyYWl0JTIwcGVyc29uJTIwZmFjZXxlbnwwfDF8fHwxNzczNzY3OTc0fDA&ixlib=rb-4.1.0&w=2000',
              type: 'portrait',
              orientation: 'portrait',
            },
          },
        ],
      },
      accountInfo: {
        companyName: {
          content: '',
        },
        fullName: {
          content: 'Mr./Mrs. Smith ',
        },
        address: {
          content: '1234 Street, New York, NY 10002',
        },
        phone: {
          content: '555-555-5555',
        },
        email: {
          content: 'anil.kamath+eccom16042025nsoll@newfold.com',
        },
      },
    },
  },
  faqs: {
    blocks: {
      faq: {
        elements: [
          {
            title: {
              content: 'Our Services',
            },
          },
          {
            description: {
              content:
                'We provide comprehensive services tailored to your business needs.',
            },
          },
          {
            title: {
              content: 'Customer Satisfaction',
            },
          },
          {
            description: {
              content:
                'Our commitment to quality ensures a satisfying experience for all clients.',
            },
          },
          {
            icon: {
              url: 'icons:38242',
              type: 'service',
            },
          },
          {
            title: {
              content: 'Industry Expertise',
            },
          },
          {
            description: {
              content:
                'Our team specializes in various industries to offer precise solutions.',
            },
          },
          {
            icon: {
              url: 'icons:74399',
              type: 'service',
            },
          },
          {
            icon: {
              url: 'icons:74415',
              type: 'service',
            },
          },
          {
            title: {
              content: 'Building Relationships',
            },
          },
          {
            description: {
              content:
                'We focus on developing lasting partnerships with our clients.',
            },
          },
          {
            icon: {
              url: 'icons:74785',
              type: 'service',
            },
          },
          {
            title: {
              content: 'Quality Assurance',
            },
          },
          {
            description: {
              content:
                'We implement strict quality controls for exceptional service delivery.',
            },
          },
          {
            icon: {
              url: 'icons:75067',
              type: 'service',
            },
          },
          {
            title: {
              content: 'Innovative Solutions',
            },
          },
          {
            description: {
              content:
                'Our approach embraces innovation to support your business growth.',
            },
          },
          {
            icon: {
              url: 'icons:86369',
              type: 'service',
            },
          },
          {
            title: {
              content: 'Get in Touch',
            },
          },
          {
            description: {
              content: 'Contact us today to discuss how we can assist you.',
            },
          },
        ],
      },
      accountInfo: {
        companyName: {
          content: '',
        },
        fullName: {
          content: 'Mr./Mrs. Smith ',
        },
        address: {
          content: '1234 Street, New York, NY 10002',
        },
        phone: {
          content: '555-555-5555',
        },
        email: {
          content: 'anil.kamath+eccom16042025nsoll@newfold.com',
        },
      },
    },
  },
  home: {
    blocks: {
      cover: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1665686308827-eb62e4f6604d?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDIwfHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            button1: {
              content: 'Learn More',
            },
          },
        ],
      },
      cover2: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDd8fGJ1c2luZXNzfGVufDB8MHx8fDE3NzM3MjM3Mjh8MA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            button1: {
              content: 'Learn More',
            },
          },
        ],
      },
      cover3: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1480944657103-7fed22359e1d?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDE0fHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            button1: {
              content: 'Get Started',
            },
          },
        ],
      },
      cover4: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDl8fGJ1c2luZXNzfGVufDB8MHx8fDE3NzM3MjM3Mjh8MA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            button1: {
              content: 'Contact Us',
            },
          },
        ],
      },
      contact: {
        elements: [
          {
            title: {
              content: 'Contact Us Today',
            },
          },
          {
            shortDescription: {
              content: "We're here to assist you with your business needs.",
            },
          },
        ],
      },
      aboutUs: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions for Your Success',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1431540015161-0bf868a2d407?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDE5fHxidXNpbmVzc3xlbnwwfDB8fHwxNzczNzIzNzI4fDA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            shortDescription: {
              content:
                'Welcome to our business platform, dedicated to providing tailored solutions that address your specific needs. We focus on a wide array of services to empower your organization and enhance performance. Our commitment to quality and customer satisfaction ensures enduring partnerships with our clients as we drive their success.',
            },
          },
        ],
      },
      testimonials: {
        elements: [
          {
            shortDescription: {
              content:
                'The services provided were exceptional and tailored to our specific needs.',
            },
          },
          {
            fullName: {
              content: 'John Doe',
            },
          },
          {
            title: {
              content: 'CEO, Tech Innovations',
            },
          },
          {
            shortDescription: {
              content:
                'Their expertise helped us streamline operations and boost productivity.',
            },
          },
          {
            fullName: {
              content: 'Jane Smith',
            },
          },
          {
            title: {
              content: 'COO, Retail Solutions',
            },
          },
          {
            shortDescription: {
              content:
                'We appreciate their professionalism and commitment to our success.',
            },
          },
          {
            fullName: {
              content: 'Alice Johnson',
            },
          },
        ],
      },
      dashbooking: {
        elements: [
          {
            shortDescription: {
              content: 'Explore tailored business solutions for your success.',
            },
          },
          {
            title: {
              content: 'Comprehensive Business Services',
            },
          },
        ],
      },
      dashstore: {
        elements: [
          {
            title: {
              content: 'Comprehensive Business Solutions',
            },
          },
          {
            image: {
              content: null,
              type: 'banner',
              orientation: 'landscape',
              url: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixid=M3wxNjk3NXwwfDF8c2VhcmNofDJ8fGJ1c2luZXNzfGVufDB8MHx8fDE3NzM3MjM3Mjh8MA&ixlib=rb-4.1.0&w=2000',
            },
          },
          {
            shortDescription: {
              content:
                'Explore extensive services designed to support your business needs and drive success.',
            },
          },
        ],
      },
      dashEntities: {
        dashbooking: {
          title: {
            content: 'Discover Our Commitment to Quality.',
          },
          description: {
            content:
              'We prioritize building lasting relationships with our clients, ensuring they receive top-notch service and support.',
          },
        },
      },
      accountInfo: {
        companyName: {
          content: '',
        },
        fullName: {
          content: 'Mr./Mrs. Smith ',
        },
        address: {
          content: '1234 Street, New York, NY 10002',
        },
        phone: {
          content: '555-555-5555',
        },
        email: {
          content: 'anil.kamath+eccom16042025nsoll@newfold.com',
        },
      },
    },
  },
  booking: {
    blocks: {
      title: {
        content: 'Discover Our Commitment to Quality.',
      },
      description: {
        content:
          'We prioritize building lasting relationships with our clients, ensuring they receive top-notch service and support.',
      },
    },
  },
  store: {
    blocks: [],
  },
}

/**
 * Provider component for AI-generated configuration data.
 * Must be rendered as a child of OnboardingContextProvider.
 *
 * Features:
 * - Shared state across all consumers (single fetch)
 * - Automatic refetch when selectedTemplate changes in OnboardingContext
 * - Lodash-like get() function for safe data access
 */
const AIConfigProvider = ({ children }) => {
  // HMR can render this before OnboardingContext.Provider reattaches; context is then undefined.
  const onboarding = useContext(OnboardingContext) ?? {}
  const {
    selectedTemplate,
    isGrid,
    gridAiPageData,
    gridGenerationStatus,
  } = onboarding
  const templateId = selectedTemplate?.id

  const [data, setData] = useState(MOCK_AI_RESPONSE)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoaded, setIsLoaded] = useState(true) // true because we start with mock data
  const [error, setError] = useState(null)

  const previousTemplateIdRef = useRef(null)

  const gridData = gridAiPageData && typeof gridAiPageData === 'object' ? gridAiPageData : {}
  const effectiveData = isGrid === true ? gridData : data
  const effectiveIsLoading =
    isGrid === true ? gridGenerationStatus === 'pending' : isLoading
  const effectiveIsLoaded =
    isGrid === true ? gridGenerationStatus !== 'pending' : isLoaded
  const effectiveError = isGrid === true ? null : error

  /**
   * Fetch AI config data for a given template ID
   * TODO: Replace with actual API call
   */
  const fetchAIConfig = useCallback(async (id) => {
    if (!id) return

    setIsLoading(true)
    setError(null)

    try {
      // TODO: Replace this with your actual API call
      // Example: const response = await getAIConfig(id)

      // Simulating API delay for now
      await new Promise((resolve) => setTimeout(resolve, 100))

      // For now, just return mock data
      // Replace this with: setData(response.data)
      setData(MOCK_AI_RESPONSE)
      setIsLoaded(true)
    } catch (err) {
      console.error('Error fetching AI config:', err)
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }, [])

  /**
   * Safely get a value from the AI config data
   * Works like lodash's get() function
   *
   * @param {string|Array} path - Path to the value (e.g., 'pages.home.hero.headline')
   * @param {*} defaultValue - Value to return if path doesn't exist
   * @returns {*} The value at the path or the default value
   *
   * @example
   * const headline = get('pages.home.hero.headline', 'Default Headline')
   * const features = get('pages.home.features', [])
   */
  const get = useCallback(
    (path, defaultValue = undefined) => {
      return getByPath(effectiveData, path, defaultValue)
    },
    [effectiveData],
  )

  /**
   * Check if a path exists in the data (value is not undefined/null)
   */
  const has = useCallback(
    (path) => {
      const value = getByPath(effectiveData, path)
      return value != null
    },
    [effectiveData],
  )

  // Non-grid: refetch mock when template changes. Grid uses sitewizard pipeline instead.
  useEffect(() => {
    if (isGrid === true) return
    if (templateId && templateId !== previousTemplateIdRef.current) {
      previousTemplateIdRef.current = templateId
      fetchAIConfig(templateId)
    }
  }, [templateId, fetchAIConfig, isGrid])

  const value = useMemo(
    () => ({
      data: effectiveData,
      get,
      has,
      isLoading: effectiveIsLoading,
      isLoaded: effectiveIsLoaded,
      error: effectiveError,
    }),
    [effectiveData, get, has, effectiveIsLoading, effectiveIsLoaded, effectiveError],
  )

  return (
    <AIConfigContext.Provider value={value}>
      {children}
    </AIConfigContext.Provider>
  )
}

AIConfigProvider.propTypes = {
  children: PropTypes.node,
}

export default AIConfigProvider
